import { render, staticRenderFns } from "./BvaTodLessons.vue?vue&type=template&id=c0fba5d4&scoped=true&"
import script from "./BvaTodLessons.vue?vue&type=script&lang=ts&"
export * from "./BvaTodLessons.vue?vue&type=script&lang=ts&"
import style0 from "./BvaTodLessons.vue?vue&type=style&index=0&id=c0fba5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fba5d4",
  null
  
)

export default component.exports